module.exports = __webpack_public_path__ + "static/img/104.bee0b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/104.png
// module id = o55v
// module chunks = 0